import { Virtuoso } from "react-virtuoso";
import Loader from "../../Loader/Loader";
import useApiHttp from "../../../../hooks/use-http";
import { useCallback, useEffect, useState } from "react";
import { Box } from "@mui/material";
import {
  Button,
  Container,
  Divider,
  Icon,
  InputCheckbox,
  Notifications,
  Text,
} from "@jds/core";
import MuiPopover from "../../MuiPopover";

const PhotographerAccess = ({ folderData = {}, closeModal = () => {} }) => {
  const {
    sendRequest: getPhotographerDataAPI,
    isLoading: photographerDataGetting,
  } = useApiHttp();

  const {
    sendRequest: setPhotographerAccessAPI,
    isLoading: photographerAccessSetting,
  } = useApiHttp();

  const [page, setPage] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [photographerList, setPhotographerList] = useState([]);
  const [selectedId, setSelectedId] = useState([]);
  const [folderAccess, setFolderAccess] = useState(false);
  const controller = new AbortController();

  const getPhotographer = () => {
    getPhotographerDataAPI(
      {
        url: `attendee-folders/${folderData.id}/photographers?page=${page}&size=100`,
        signal: controller.signal,
      },
      null,
      (data) => {
        setLastPage(data?.data?.lastPage);
        console.log("hello1234==>", data);

        if (page == 0) {
          setPhotographerList(data?.data?.results);
        } else {
          setPhotographerList((pre) => [...pre, ...data?.data?.results]);
        }
      },
      () => {}
    );
  };
  const setPhotographerAccess = () => {
    setPhotographerAccessAPI(
      {
        url: `attendee-folders/${folderData.id}/assign-photographers`,
        method: "POST",
        body: {
          photographerIds: selectedId,
        },
      },
      null,
      (data) => {
        closeModal();
        Notifications.toast.success({
          id: "photographer-access",
          title: data.message,
        });
      },
      (err, data) => {
        Notifications.toast.error({
          id: "photographer-access",
          title: data.message,
        });
      }
    );
  };

  const handleCheckboxChange = useCallback((checked, index, id) => {
    if (checked) {
      setSelectedId((pre) => [...pre, id]);
    } else {
      setSelectedId((pre) => pre.filter((item) => item !== id));
    }
  }, []);

  useEffect(() => {
    getPhotographer();
    return () => {
      controller.abort();
    };
  }, [page, folderData.id]);
  return (
    <div>
      <div style={{ marginBottom: "24px" }}>
        <Text
          text={`Select Photographers for: ${folderData.name || ""} `}
          appearance="body-m-bold"
        />
        <Box my={2}>
          <Divider pad="none" padPosition="vertical" />
        </Box>
      </div>

      <Virtuoso
        style={{
          height: "60vh",
        }}
        className="custom-scrollbar"
        data={photographerList}
        endReached={() => {
          if (lastPage > page) {
            setPage(page + 1);
          }
        }}
        increaseViewportBy={10}
        itemContent={(index, item) => {
          return (
            <RowElement
              photographer={item}
              index={index}
              handleCheckboxChange={handleCheckboxChange}
            />
          );
        }}
        components={{ Footer: photographerDataGetting ? Footer : "" }}
      />
      <Box my={2}>
        <Divider pad="none" padPosition="vertical" />
      </Box>
      <Container fullWidth horizontalAlign="end" gap={12}>
        <Button
          label="Cancel"
          size="small"
          kind="secondary"
          onClick={() => {
            closeModal();
          }}
        />
        <Button
          label="Save"
          size="small"
          onClick={() => {
            if (selectedId.length > 0) {
              setPhotographerAccess();
            } else {
              closeModal();
            }
          }}
          disabled={photographerAccessSetting}
        />
      </Container>
    </div>
  );
};

const RowElement = ({
  photographer,
  index,
  handleCheckboxChange = () => {},
}) => {
  return (
    <>
      <Box width={"100%"} key={index}>
        <Container
          fullWidth
          verticalAlign="center"
          horizontalAlign="space-between"
        >
          <Box
            sx={{
              "& .j-JDSCheckbox-horizontal-container": {
                gap: "14px",
              },
              "& .j-JDSCheckbox-label-jds-text": {
                fontFamily: "var(--font-families-body-m)",
                color: "var(--color-primary-gray)",
              },
            }}
          >
            <InputCheckbox
              label={`${photographer?.name}`}
              checked={photographer?.active}
              onChange={(e) => {
                handleCheckboxChange(
                  photographer?.active === e.target.checked ? false : true,
                  index,
                  photographer?.userId
                );
              }}
            />
          </Box>
        </Container>
        <Box my={2}>
          <Divider pad="none" padPosition="vertical" />
        </Box>
      </Box>
    </>
  );
};
const Footer = () => {
  return (
    <Loader size="small" containerProps={{ style: { marginTop: "16px" } }} />
  );
};

const DropBtn = (props) => (
  <Button
    label="Select Access"
    size="small"
    kind="secondary"
    icon={"IcChevronDown"}
    {...props}
  />
);

export default PhotographerAccess;
